import { render } from "./Index.vue?vue&type=template&id=45f6875b&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=45f6875b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f6875b"],['__file',"src/assets/js/pages/AddIntercom/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45f6875b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45f6875b', __exports__)) {
    api.reload('45f6875b', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=45f6875b&scoped=true", () => {
    api.rerender('45f6875b', render)
  })

}


export default __exports__